const getNewCaptcha = () => {
    $.get("GetNewCaptcha")
        .then((data) => {
            if (data) {
                const { srcImage } = data;
                $(".captcha-image").attr("src", srcImage);
                $(".captcha-result").val("");
                $(".captcha-section").removeClass("hidden");
                // 重新產生驗證碼會清空輸入，需重新評估登入按鈕狀態（應重回 disabled）
                if (typeof checkShowLoginButton === "function") {
                    checkShowLoginButton();
                }
            } else {
                throw Error(`invalid captchaData => ${data}`);
            }
        });
};

$(function () {
    getNewCaptcha();
    $(".renew-captcha").click(getNewCaptcha);
});
